<template>
  <div class="container py-5" v-if="user">
    <div class="row">
      <div class="col-lg-12">
        <div class="_header text-center">
          <div class="_profile">
            <img :src="user.avatar" alt="" class="shadow-lg rounded-circle" width="100" height="100">
            <div class="_name my-3">
              <h4 class="m-0">
                <i class="fas fa-globe-americas text-primary" v-if="user.public"></i>
                <i class="fas fa-lock text-primary" v-if="!user.public"></i>
                {{user.name + ' ' + user.lname}}
              </h4>
              <small>Ultima actualización: {{ user.updated_at | timeDate }}</small>
            </div>
            <div class="row my-5">
              <div class="_location col-sm-12 col-md" v-if="user.student_info && user.student_info.location">
                <h4><i class="fas fa-location-arrow text-primary"></i> Ubicación </h4>
                {{user.student_info.location}}
              </div>

              <div class="_phone col-sm-12 col-md" v-if="(user.student_info && user.student_info.phone) && contacted.is_contacted  || (user.student_info && user.student_info.phone) && course.price_val == 'No'">
                <h4><i class="fas fa-phone text-primary"></i> Teléfono de contacto</h4>
                {{user.student_info.phone}}
              </div>

              <div class="_birtday col-sm-12 col-md" v-if="(user && user.email) && contacted.is_contacted  || (user && user.email) &&  course.price_val == 'No'">
                <h4><i class="fas fa-at text-primary" aria-hidden="true"></i> Dirección de correo</h4>
                {{user.email}}
              </div>

              <div class="_birtday col-sm-12 col-md" v-if="user.student_info && user.student_info.birthday">
                <h4><i class="fa fa-birthday-cake text-primary" aria-hidden="true"></i> Fecha de nacimiento</h4>
                {{user.student_info.birthday}}
              </div>
            </div>
            <div class="row">
              <div class="_biography col" v-if="user.student_info && user.student_info.biography">
                <h4><i class="fa fa-address-card text-primary" aria-hidden="true"></i> Biografía</h4>
                <p class="text-justify">{{user.student_info.biography}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div class="isContacted" v-if="contacted.is_contacted">
      <div class="_phone font-orange" v-if="user.student_info && user.student_info.phone">
        Teléfono de contacto<br>
        <i class="fas fa-phone b-orange p-2 rounded shadow"></i> {{user.student_info.phone}}
      </div>
      <div class="_phone mt-2 font-orange" v-if="user && user.email">
        Dirección de correo<br>
        <i class="fas fa-at b-orange p-2 rounded shadow"></i> {{user.email}}
      </div>
      <br>
    </div> -->

    <div v-if="!contacted.is_contacted && course.price_val == 'Si'" class="py-3 text-center">
      <h2 class="fas fa-lock"></h2>
      <h5>Información oculta</h5>

      <b-button class="b-orange shadow-sm my-3" @click="buyUser" :disabled="loading">
        <i class="fas fa-user-plus" v-show="!loading"></i>
        <b-spinner v-show="loading" small label="Espere ..."></b-spinner>
        Ver Información
      </b-button>


      <div v-if="errors && !loading">

        <div class="errors b-red p-3 my-4 rounded shadow">
          <i class="fas fa-exclamation-triangle"></i>
          {{ errors.message }}
        </div>

<!--        <i class="fas fa-exclamation-triangle fa-lg font-red my-3"></i>-->
        <!-- <p class="text-white h4">
          Para ver la información de contacto de este candidato,
          <br> es necesario que adquieras una membresía
        </p>
        <b-button @click="toMemeber" class="btn btn-light my-2 shadow-sm">
          Ver membresías
        </b-button> -->

      </div>

    </div>
    
     <template v-if="contacted.is_contacted  || course.price_val == 'No'"><br><br><br><br><br></template>
  </div>
  <!--  <div class="text-center">-->
  <!--    <img :src="user.avatar" alt="" class="shadow-lg rounded-circle" width="100" height="100">-->
  <!--    <div class="_name my-3">-->
  <!--      <h4 class="m-0">-->
  <!--        <i class="fas fa-globe-americas" v-if="user.public"></i>-->
  <!--        <i class="fas fa-lock" v-if="!user.public"></i>-->
  <!--        {{user.name + ' ' + user.lname}}</h4>-->
  <!--      <small>Ultima actualización: {{ user.updated_at | timeDate }}</small>-->
  <!--    </div>-->
  <!--    <div class="_location" v-if="user.student_info && user.student_info.location">-->
  <!--      Ubicación <br>-->
  <!--      <i class="fas fa-location-arrow"></i> {{user.student_info.location}}-->
  <!--    </div>-->
  <!--    <br>-->
  <!--    <div class="_biography" v-if="user.student_info && user.student_info.biography">-->
  <!--      Biografía <br>-->
  <!--      <span style="white-space: pre-wrap;">{{user.student_info.biography}}</span>-->
  <!--    </div>-->
  <!--    <br>-->
  <!--    <div class="_birtday" v-if="user.student_info && user.student_info.birthday">-->
  <!--      Fecha de nacimiento <br>-->
  <!--      {{user.student_info.birthday}}-->
  <!--    </div>-->



<!--  </div>-->
</template>
<script>
  export default {
    props: {
      user: Object,
      isGold: {
        type: Boolean,
        default: false
      },
      job_id: Number,
      contacted: Object,
      course: Object,
      total: Number,
    },
    data() {
      return {
        from_search: false,
        loading: false,
        sendMessageLoading: false,
        errors: false
      }
    },
    methods: {
      buyUser() {
        let form = {
          user_id: this.user.id,
          from_search: this.from_search,
          curse_id: this.course.id
        }
        console.log(form)

        this.loading = true
        this.api.post('candidate/buyCourse', JSON.stringify(form)).then(({data}) => {
          this.bus.$emit("getStudents")
          location.reload()
        }).catch(err => {
          if (err.response.status == 403) {
            this.errors = err.response.data
          }
          this.errors = err.response.data
          this.loading = false
        })
      },
      toMemeber(){
        this.$router.push("/memberships")
      }
    },
    created() {
      if (this.$route.query.from_search !== undefined && this.$route.query.from_search) {
        this.from_search = true;
      } 
    } 
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/curses/elements/General.vue